import { render, staticRenderFns } from "./MallShopAdd.vue?vue&type=template&id=546fd3fa&scoped=true"
import script from "./MallShopAdd.vue?vue&type=script&lang=js"
export * from "./MallShopAdd.vue?vue&type=script&lang=js"
import style0 from "./MallShopAdd.vue?vue&type=style&index=0&id=546fd3fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546fd3fa",
  null
  
)

export default component.exports